import {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'

import {useStaticPartsTypesQuery} from './queries/useStaticPartsTypesQuery'

import {StaticPartComponentTypeEnum} from '@refra/modules/refra-static-parts/enums'

export const useStaticPartsTypeOptions = () => {
  const {data: staticPartsTypes} = useStaticPartsTypesQuery()
  const {t} = useTranslation()
  const [equipmentTypeOptions, setEquipmentTypeOptions] = useState<
    {value: string; label: string}[]
  >([])

  useEffect(() => {
    if (staticPartsTypes) {
      setEquipmentTypeOptions([])
      Object.keys(staticPartsTypes).forEach((key) => {
        setEquipmentTypeOptions((prev) => [
          ...prev,
          {value: key, label: t(`staticParts.equipmentType.${key}`)}
        ])
      })
    }
  }, [staticPartsTypes, t])

  const getStaticPartComponents = (equipmentType: string) => {
    const components: StaticPartComponentTypeEnum[] = staticPartsTypes?.[equipmentType] ?? []
    return components
  }

  return {
    equipmentTypeOptions,
    staticPartsTypes: staticPartsTypes ?? [],
    getStaticPartComponents
  }
}
